
import { useTranslation } from "react-i18next";
import HeroSection from "@/components/individuals/HeroSection";
import VaeFeaturesSection from "@/components/individuals/VaeFeaturesSection";
import VaeSection from "@/components/individuals/VaeSection";
import PublicServiceSection from "@/components/individuals/PublicServiceSection";
import CompetitionSection from "@/components/individuals/CompetitionSection";

const Individuals = () => {
  const { t } = useTranslation('individuals');

  return (
    <div className="bg-background">
      <HeroSection />
      <VaeFeaturesSection />
      <VaeSection />
      <PublicServiceSection />
      <CompetitionSection />
    </div>
  );
};

export default Individuals;
